import React, { useRef, useState } from "react";

import ReactToPrint from "react-to-print";

import { Flex, Spinner, Text } from "@chakra-ui/react";

import CriancaService from "../../../main/services/CriancaService";
import { FaFilePdf } from "react-icons/fa";
import { ComponentToPrintCriancaPendencia } from "../ComponentToPrintCriancaPendencia";

export const PrintButtonPendencias = ({ idCrianca, dados, user }) => {
  const componentToPrintRef = useRef(null);
  const [dataPendencias, setDataPendencias] = useState([]);
  const [columnsPendencias, setColumnsPendencias] = useState([]);
  const [loading, setLoading] = useState(false);

  const beforeGetContent = async () => {
    setLoading(true);
    try {
      const res = await CriancaService.getPendencias(idCrianca);

      if (res?.data) {
        setColumnsPendencias([
          {
            Header: "Pendências",
            accessor: "descricaoTipoPendencia",
            Cell: (props) => {
              const pendencia = props?.value;

              return <span>{pendencia ? pendencia : ""}</span>;
            },
          },
          {
            Header: "Aba",
            accessor: "nomeAba",
            Cell: (props) => {
              const nomeAba = props?.value;

              return <span>{nomeAba ? nomeAba : ""}</span>;
            },
          },
        ]);
      }

      setDataPendencias(res?.data);

      setLoading(false);
    } catch (erro) {
      console.log("Erro ao acessar os dados de impressao");
      console.log(erro);
      setLoading(false);
    }
  };

  const customPageStyle = `
    @page {
      margin: 0mm;
      size: auto;  
      margin-top: 0mm; 
      margin-bottom: 12mm; 
    } 
    @media print { 
      body { 
        -webkit-print-color-adjust: exact; 
      } 
    }
  `;

  return (
    <>
      <ReactToPrint
        onBeforeGetContent={beforeGetContent}
        onAfterPrint={() => setLoading(false)}
        pageStyle={customPageStyle}
        documentTitle={dados && `MCA - ${dados.nome}`}
        trigger={() => {
          return loading ? (
            <Spinner size="sm" />
          ) : (
            <Flex
              alignItems="center"
              gap={2}
              cursor="pointer"
              onClick={() => alert("imprimir PDF")}
            >
              <Flex bg="red" rounded="full" p={1}>
                <FaFilePdf color="white" />
              </Flex>

              <Text as="b" color="red" fontSize={"md"}>
                Exportar em PDF
              </Text>
            </Flex>
          );
        }}
        content={() => componentToPrintRef.current}
      />
      <div style={{ display: "none" }}>
        <ComponentToPrintCriancaPendencia
          ref={componentToPrintRef}
          dataPendencias={dataPendencias ? dataPendencias : null}
          columnsPendencias={columnsPendencias}
          idCrianca={idCrianca}
          dados={dados}
          user={user}
        />
      </div>
    </>
  );
};
